// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"b3c2c078","349":"9e169fe2","365":"118de4a5","368":"058a0c4e","453":"3be0207c"}[chunkId] + ".chunk.js";
};